import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../components/Notification';
import HttpStatus from '../../../../../enums/httpStatus';
import { getApi } from '../../../../../services/api';
import { databaseManagement } from '../../../../../services/endpoints';
import { DbMapItem } from '../index';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  item: DbMapItem;
  onSuccess: () => void;
};

const EditDbMapModal = ({ showModal, closeModal, item, onSuccess }: Props) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [table, setTable] = useState('');
  const [column, setColumn] = useState('');
  const [reference, setReference] = useState('');

  useEffect(() => {
    setTable(item.table);
    setColumn(item.column);
    setReference(item.reference);
  }, [item]);

  const handleUpdate = async () => {
    setIsLoading(true);

    try {
      const payload = {
        table,
        column,
        reference,
        old_table: item.table,
        old_column: item.column,
        old_reference: item.reference,
      };

      const api = await getApi();
      const res = await api.put(databaseManagement['/db-map'], payload);

      if (res.status === HttpStatus.OK) {
        frontendNotification({
          message: t('successfullyUpdated'),
          type: 'success',
        });

        closeModal();
        onSuccess();
      } else {
        throw res;
      }
    } catch (err) {
      backendErrorNotification(err as AxiosError<any, any>);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={t('editDbMap')}
      showModal={showModal}
      closeModal={closeModal}
      action={handleUpdate}
      isLoading={isLoading}
    >
      <div className="form">
        <div className="form-row">
          <div className="form-row-item">
            <label htmlFor="dbMapTableEdit">{t('table') as string}</label>
            <input
              id="dbMapTableEdit"
              type="text"
              value={table}
              onChange={(e) => setTable(e.target.value)}
              disabled={isLoading}
            />
          </div>
          <div className="form-row-item">
            <label htmlFor="dbMapColumnEdit">{t('column') as string}</label>
            <input
              id="dbMapColumnEdit"
              type="text"
              value={column}
              onChange={(e) => setColumn(e.target.value)}
              disabled={isLoading}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <label htmlFor="dbMapReferenceEdit">{t('reference') as string}</label>
            <input
              id="dbMapReferenceEdit"
              type="text"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditDbMapModal;
